import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import { OfferCardsMobile } from './OfferCardsMobile';
import { OfferCardsDesktop } from './OfferCardsDesktop';
import { getOfferCards } from './utils';
export function OfferCards({ offer }) {
    const [offerCards, setOfferCards] = useState([]);
    const { isMobile } = useBreakpoint();
    useEffect(() => {
        setOfferCards(getOfferCards(offer));
    }, [offer]);
    return (_jsx(_Fragment, { children: isMobile ? (_jsx(OfferCardsMobile, { offerCards: offerCards })) : (_jsx(OfferCardsDesktop, { offerCards: offerCards })) }));
}
